<div class="shell-wrapper" [class.native-tablet-shell]="isNativeTabletLayout">
    <div role="alert" *ngIf="addons.error">{{ addons.error }} <button type="button" (click)="reloadAddons()">Retry</button></div>
    <!-- Mobile overlay backdrop -->
    <div class="mobile-backdrop" *ngIf="mobileOpen" (click)="closeMobile()"></div>
    <div class="desktop-backdrop" *ngIf="desktopSidebarOpen" (click)="closeDesktopSidebar()"></div>

    <!-- Sidebar -->
    <nav class="sidebar" [class.collapsed]="sidebarCollapsed" [class.mobile-open]="mobileOpen" [class.desktop-open]="desktopSidebarOpen">
        <div class="sidebar-header">
            <div class="brand">
                <img src="assets/milkomatic-logo.png" class="brand-logo" alt="Milkomatic" />
            </div>
            <button class="collapse-btn desktop-only" (click)="closeDesktopSidebar()" title="Close sidebar">
                <i class="pi pi-times"></i>
            </button>
            <button class="collapse-btn mobile-only" (click)="closeMobile()" title="Close menu">
                <i class="pi pi-times"></i>
            </button>
        </div>

        <!-- Dairy Info Card -->
        <div class="sidebar-dairy" *ngIf="dairy">
            <!-- Collapsed: icon only -->
            <div class="sd-collapsed" *ngIf="sidebarCollapsed && !mobileOpen" [title]="dairy.company_name">
                <span class="sd-icon">🏪</span>
            </div>
            <!-- Expanded -->
            <div class="sd-expanded" *ngIf="!sidebarCollapsed || mobileOpen">
                <div class="sd-top-row">
                    <div class="sd-avatar">🏪</div>
                    <div class="sd-info">
                        <select class="sd-dairy-select"
                                *ngIf="currentUser?.dairies?.length > 1; else singleDairyName"
                                [value]="dairy.id"
                                (change)="switchDairy($event)"
                                aria-label="Current dairy">
                            <option *ngFor="let option of currentUser.dairies" [value]="option.id">
                                {{ option.company_name }}
                            </option>
                        </select>
                        <ng-template #singleDairyName><div class="sd-name">{{ dairy.company_name }}</div></ng-template>
                        <div class="sd-id-row">
                            <span class="sd-id">#{{ dairy.id }}</span>
                            <span class="sd-status" [class.pending]="dairySubscriptionStatus !== 'ACTIVE'">
                                {{ dairySubscriptionStatus }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="sd-details">
                    <div class="sd-detail-row" *ngIf="dairy.city">
                        <i class="pi pi-map-marker"></i>
                        <span>{{ dairy.city }}<span *ngIf="dairy.states">, {{ dairy.states }}</span></span>
                    </div>
                    <div class="sd-detail-row" *ngIf="dairy.mobile">
                        <i class="pi pi-phone"></i>
                        <span>{{ dairy.mobile }}</span>
                    </div>
                </div>
                <div class="sd-badges-row">
                    <span class="sd-plan-badge" [ngClass]="planBadgeClass">{{ planType }}</span>
                    <span class="sd-expiry" [class.urgent]="expiryUrgent" *ngIf="expiryLabel">
                        <i class="pi pi-calendar"></i> {{ expiryLabel }}
                    </span>
                </div>
            </div>
        </div>

        <div class="sidebar-footer" *ngIf="!sidebarCollapsed || mobileOpen">
            <!-- Language + Theme row (visible in sidebar on mobile) -->
            <div class="sb-settings-row mobile-only">
                <div class="sb-lang-inline">
                    <button class="sb-lang-toggle" (click)="showLangMenu = !showLangMenu">
                        <i class="pi pi-language"></i>
                        <span>{{ languageService.currentLanguage.nativeLabel }}</span>
                        <i class="pi pi-chevron-down sb-lang-caret" [class.open]="showLangMenu"></i>
                    </button>
                    <div class="sb-lang-options" *ngIf="showLangMenu">
                        <button class="sb-lang-opt"
                            *ngFor="let lang of languages"
                            [class.active]="lang.code === currentLang"
                            (click)="switchLanguage(lang.code)">
                            <span class="sb-lang-native">{{ lang.nativeLabel }}</span>
                            <span class="sb-lang-name">{{ lang.label }}</span>
                            <i class="pi pi-check" *ngIf="lang.code === currentLang"></i>
                        </button>
                    </div>
                </div>
                <button class="theme-toggle-btn" (click)="toggleTheme()" [title]="isDarkTheme ? ('topbar.light_mode' | translate) : ('topbar.dark_mode' | translate)">
                    <i class="pi" [ngClass]="isDarkTheme ? 'pi-sun' : 'pi-moon'"></i>
                </button>
            </div>

            <!-- Bluetooth Printer Settings -->
                        <button class="sb-announcement"
                                        *ngIf="sysAnnouncement"
                                        (click)="openAnnouncement()">
                            <span class="sb-announcement-icon" [ngClass]="'ann-' + sysAnnouncement.type">
                                <i class="pi" [ngClass]="announcementIcon"></i>
                            </span>
                            <span class="sb-announcement-copy">
                                <span class="sb-announcement-label">Announcements</span>
                                <span class="sb-announcement-sub">{{ announcementTypeLabel }}</span>
                            </span>
                            <span class="sb-announcement-new" *ngIf="!sysAnnDismissed">New</span>
                            <i class="pi pi-chevron-right sb-announcement-arrow"></i>
                        </button>

                        <!-- Bluetooth Printer Settings -->
            <button class="sb-bt-settings"
                    (click)="btService.openPickerForPrint(noOpBtCallback)"
                    [class.sb-bt-settings--paired]="btService.isPaired">
              <i class="pi pi-wifi"></i>
              <span class="sb-bt-label">BT Printer</span>
              <span class="sb-bt-status">{{ btService.pairedLabel }}</span>
            </button>

            <!-- Need Help? -->
            <a class="sb-need-help" href="https://wa.me/917015158036" target="_blank">
                <div class="sb-need-help-icon">🎧</div>
                <div class="sb-need-help-text">
                    <span class="sb-need-help-label">{{ 'shell.need_help' | translate }}</span>
                    <span class="sb-need-help-sub">{{ 'shell.contact_support' | translate }}</span>
                </div>
            </a>

            <!-- App Version -->
            <div class="sb-version">{{ 'brand.name' | translate }} &nbsp;&middot;&nbsp; v{{ appVersion }}</div>
        </div>
    </nav>

    <!-- ── GLOBAL BT PRINTER PICKER (rendered at shell root — no stacking context issues) ── -->
    <app-bt-printer-picker
      [visible]="btService.showPicker"
      (closed)="btService.handlePickerClosed()"
      (deviceSelected)="btService.handlePickerSelected($event)">
    </app-bt-printer-picker>

    <!-- ── SYSTEM ANNOUNCEMENT ── -->
    <div class="announcement-modal-backdrop" *ngIf="showAnnouncementModal && !showCreateDairy" (click)="dismissAnnouncement()"></div>
    <section class="announcement-modal ann-{{ sysAnnouncement?.type }}"
             *ngIf="showAnnouncementModal && sysAnnouncement && !showCreateDairy"
             role="dialog" aria-modal="true" aria-labelledby="announcement-title">
        <button class="announcement-modal-close" (click)="dismissAnnouncement()" title="Close announcement">
            <i class="pi pi-times"></i>
        </button>
        <div class="announcement-modal-accent"></div>
        <div class="announcement-modal-content">
            <div class="announcement-modal-icon"><i class="pi" [ngClass]="announcementIcon"></i></div>
            <div class="announcement-modal-type">{{ announcementTypeLabel }}</div>
            <h2 id="announcement-title">{{ sysAnnouncement.title || 'Milkomatic announcement' }}</h2>
            <p>{{ sysAnnouncement.message }}</p>
        </div>
        <footer class="announcement-modal-footer">
            <span><i class="pi pi-megaphone"></i> Milkomatic</span>
            <button type="button" (click)="dismissAnnouncement()">
                <i class="pi pi-check"></i> Got it
            </button>
        </footer>
    </section>

    <!-- ── EDIT PROFILE DIALOG ── -->
    <div class="dlg-backdrop" *ngIf="showEditProfile"></div>
    <div class="dlg-panel" *ngIf="showEditProfile" [formGroup]="profileForm">
        <div class="dlg-header">
            <div class="dlg-icon teal"><i class="pi pi-user-edit"></i></div>
            <div>
                <div class="dlg-title">Edit Profile</div>
                <div class="dlg-sub">Update your account details</div>
            </div>
            <button class="dlg-close" (click)="showEditProfile=false"><i class="pi pi-times"></i></button>
        </div>
        <div class="dlg-body">
            <div class="dlg-grid">
                <div class="dlg-field dlg-field-full">
                    <label>Full Name *</label>
                    <input type="text" formControlName="name" placeholder="Your full name" />
                </div>
                <div class="dlg-field">
                    <label>Email</label>
                    <input type="email" formControlName="email" placeholder="Email address" />
                </div>
                <div class="dlg-field">
                    <label>Mobile</label>
                    <input type="text" formControlName="mobile" placeholder="Mobile number" />
                </div>
            </div>
        </div>
        <div class="dlg-footer">
            <div class="dlg-msg" [class.dlg-success]="editProfileMsg==='success'" *ngIf="editProfileMsg">
                {{ editProfileMsg === 'success' ? '✓ Profile updated!' : editProfileMsg }}
            </div>
            <button class="dlg-cancel" (click)="showEditProfile=false">Cancel</button>
            <button class="dlg-save" (click)="saveProfile()" [disabled]="profileForm.invalid || savingProfile">
                <i class="pi" [ngClass]="savingProfile ? 'pi-spin pi-spinner' : 'pi-check'"></i>
                {{ savingProfile ? 'Saving…' : 'Save' }}
            </button>
        </div>
    </div>

    <!-- ── CREATE DAIRY WIZARD (first login — mandatory, no dismiss) ── -->
    <div class="dlg-backdrop create-dairy-backdrop" *ngIf="showCreateDairy"></div>
    <div class="dlg-panel dlg-wide create-dairy-panel" *ngIf="showCreateDairy" [formGroup]="createDairyForm">
        <div class="dlg-header">
            <div class="dlg-icon teal"><i class="pi pi-building"></i></div>
            <div>
                <div class="dlg-title">Set Up Your Dairy</div>
                <div class="dlg-sub">Welcome! Let's create your dairy profile to get started.</div>
            </div>
        </div>
        <div class="dlg-body">

            <!-- Plan limit block: shown instead of form when user has reached their dairy limit -->
            <div class="plan-limit-block" *ngIf="!planService.canCreateDairy(); else createDairyForm_tpl">
                <div class="plb-icon">🔒</div>
                <div class="plb-title">Dairy Limit Reached</div>
                <div class="plb-msg">{{ createDairyMsg || ('Your ' + planService.getPlanType() + ' plan allows a maximum of ' + planService.getMaxDairies() + ' dairy.') }}</div>
                <ng-container *ngIf="!isPlayStoreBuild">
                    <div class="plb-hint">To manage multiple dairies, please upgrade to the <strong>PREMIUM</strong> plan.</div>
                    <div class="plb-actions">
                        <button class="dlg-btn-outline" (click)="showCreateDairy = false">Close</button>
                        <a class="dlg-btn-primary" href="mailto:support@milkomatic.co.in" target="_blank">Contact Support to Upgrade</a>
                    </div>
                </ng-container>
                <ng-container *ngIf="isPlayStoreBuild">
                    <div class="plb-hint">To add more dairies, please contact our support team.</div>
                    <div class="plb-actions">
                        <button class="dlg-btn-outline" (click)="showCreateDairy = false">Close</button>
                        <a class="dlg-btn-primary" href="mailto:support@milkomatic.co.in" target="_blank">Contact Support</a>
                    </div>
                </ng-container>
            </div>

            <ng-template #createDairyForm_tpl>
            <div class="create-dairy-welcome">
                <i class="pi pi-star-fill" style="color:#f59e0b"></i>
                You're logged in for the first time. Please fill in your dairy details below.
                Only the <strong>Dairy Name</strong> is required — you can update the rest later.
            </div>

            <div class="dlg-section-title">Basic Information</div>
            <div class="dlg-grid">
                <div class="dlg-field dlg-field-full">
                    <label>Dairy Name <span class="req">*</span></label>
                    <input type="text" formControlName="company_name" placeholder="e.g. Shree Ram Dairy" />
                    <small class="dlg-err" *ngIf="createDairyForm.get('company_name')?.invalid && createDairyForm.get('company_name')?.touched">
                        Dairy name is required.
                    </small>
                </div>
                <div class="dlg-field dlg-field-full">
                    <label>Printing Name</label>
                    <input type="text" formControlName="print_name" placeholder="Name printed on bills (optional)" />
                </div>
                <div class="dlg-field">
                    <label>Mobile</label>
                    <input type="text" formControlName="mobile" placeholder="Contact mobile" />
                </div>
                <div class="dlg-field">
                    <label>Email</label>
                    <input type="email" formControlName="email" placeholder="Business email" />
                </div>
            </div>

            <div class="dlg-section-title">Address <span class="optional-label">(optional)</span></div>
            <div class="dlg-grid">
                <div class="dlg-field dlg-field-full">
                    <label>Address</label>
                    <input type="text" formControlName="address1" placeholder="Street / locality" />
                </div>
                <div class="dlg-field dlg-field-full">
                    <label>Address Line 2</label>
                    <input type="text" formControlName="address2" placeholder="Area / landmark" />
                </div>
                <div class="dlg-field">
                    <label>State</label>
                    <input type="text" formControlName="states" placeholder="State" />
                </div>
                <div class="dlg-field">
                    <label>City</label>
                    <input type="text" formControlName="city" placeholder="City" />
                </div>
                <div class="dlg-field">
                    <label>Pincode</label>
                    <input type="text" formControlName="pincode" placeholder="Pincode" maxlength="10" />
                </div>
            </div>

            <div class="dlg-msg success" *ngIf="createDairyMsg === 'success'">
                <i class="pi pi-check-circle"></i> Dairy created successfully! Setting up your workspace…
            </div>
            <div class="dlg-msg warning" *ngIf="createDairyMsg === 'warning'" style="background:#fffbea;border:1px solid #f59e0b;color:#92400e;border-radius:6px;padding:0.7rem 1rem;display:flex;align-items:flex-start;gap:0.5rem;">
                <i class="pi pi-exclamation-triangle" style="margin-top:2px"></i>
                <div>
                  <strong>Dairy created!</strong> A minor setup step had an error, but your dairy is ready.<br>
                                    Loading your workspace automatically…
                </div>
            </div>
            <div class="dlg-msg error" *ngIf="createDairyMsg && createDairyMsg !== 'success' && createDairyMsg !== 'warning' && planService.canCreateDairy()">
                <i class="pi pi-times-circle"></i> {{ createDairyMsg }}
            </div>
            </ng-template>
        </div>
        <div class="dlg-footer" *ngIf="planService.canCreateDairy()">
            <button class="dlg-btn primary create-dairy-submit"
                (click)="submitCreateDairy()"
                [disabled]="createDairyForm.invalid || creatingDairy || createDairyMsg === 'success' || createDairyMsg === 'warning'">
                <i class="pi" [ngClass]="creatingDairy ? 'pi-spin pi-spinner' : 'pi-check'"></i>
                {{ creatingDairy ? 'Creating Dairy…' : 'Create Dairy & Continue' }}
            </button>
        </div>
    </div>

    <!-- ── EDIT DAIRY DIALOG ── -->
    <div class="dlg-backdrop" *ngIf="showEditDairy"></div>
    <div class="dlg-panel dlg-wide" *ngIf="showEditDairy" [formGroup]="dairyForm">
        <div class="dlg-header">
            <div class="dlg-icon teal"><i class="pi pi-building"></i></div>
            <div>
                <div class="dlg-title">Edit Dairy Info</div>
                <div class="dlg-sub">Update your dairy details</div>
            </div>
            <button class="dlg-close" (click)="showEditDairy=false"><i class="pi pi-times"></i></button>
        </div>
        <div class="dlg-body">

            <!-- Basic Information -->
            <div class="dlg-section-title">Basic Information</div>
            <div class="dlg-grid">
                <div class="dlg-field dlg-field-full">
                    <label>Dairy Name *</label>
                    <input type="text" formControlName="company_name" placeholder="Dairy name" />
                </div>
                <div class="dlg-field dlg-field-full">
                    <label>Printing Name</label>
                    <input type="text" formControlName="print_name" placeholder="Name used on prints" />
                </div>
                <div class="dlg-field dlg-field-full">
                    <label>Business Email</label>
                    <input type="email" formControlName="email" placeholder="Business email" />
                </div>
                <div class="dlg-field">
                    <label>Mobile Number</label>
                    <input type="text" formControlName="mobile" placeholder="Mobile" />
                </div>
                <div class="dlg-field">
                    <label>Phone Number</label>
                    <input type="text" formControlName="phone_no" placeholder="Phone" />
                </div>
            </div>

            <!-- Address Information -->
            <div class="dlg-section-title">Address Information</div>
            <div class="dlg-grid">
                <div class="dlg-field dlg-field-full">
                    <label>Business Address</label>
                    <input type="text" formControlName="address1" placeholder="Street / locality" />
                </div>
                <div class="dlg-field dlg-field-full">
                    <label>Address Line 2</label>
                    <input type="text" formControlName="address2" placeholder="Area / landmark" />
                </div>
                <div class="dlg-field">
                    <label>State</label>
                    <input type="text" formControlName="states" placeholder="State" />
                </div>
                <div class="dlg-field">
                    <label>City</label>
                    <input type="text" formControlName="city" placeholder="City" />
                </div>
                <div class="dlg-field">
                    <label>Pincode</label>
                    <input type="text" formControlName="pincode" placeholder="Pincode" maxlength="10" />
                </div>
            </div>

            <!-- Business Information -->
            <div class="dlg-section-title">Business Information</div>
            <div class="dlg-grid">
                <div class="dlg-field dlg-field-full">
                    <label>GST Number</label>
                    <input type="text" formControlName="gst_no" placeholder="GST number" />
                </div>
                <div class="dlg-field">
                    <label>State Code <span style="font-size:0.75rem;color:#888">(GST — 2 digits, e.g. 06)</span></label>
                    <input type="text" formControlName="state_code" placeholder="e.g. 06" maxlength="2" />
                </div>
                <div class="dlg-field">
                    <label>PAN Number</label>
                    <input type="text" formControlName="pan_no" placeholder="PAN number" />
                </div>
                <div class="dlg-field">
                    <label>License Number</label>
                    <input type="text" formControlName="com_lic_no" placeholder="License number" />
                </div>
            </div>

            <!-- Banking Information -->
            <div class="dlg-section-title">Banking Information</div>
            <div class="dlg-grid">
                <div class="dlg-field dlg-field-full">
                    <label>Bank Name</label>
                    <input type="text" formControlName="bank_name" placeholder="Bank name" />
                </div>
                <div class="dlg-field">
                    <label>Account Number</label>
                    <input type="text" formControlName="bank_ac" placeholder="Account number" />
                </div>
                <div class="dlg-field">
                    <label>IFSC Code</label>
                    <input type="text" formControlName="ifs_code" placeholder="IFSC code" />
                </div>
            </div>

            <div class="dlg-section-title">Application Preferences</div>
            <div class="dlg-grid">
                <div class="dlg-field dlg-field-full">
                    <label>Transaction Terminology</label>
                    <select formControlName="transaction_terminology">
                        <option *ngFor="let option of transactionTerminologyOptions" [value]="option.value">{{ option.label }}</option>
                    </select>
                    <small>Switch financial labels between Credit / Debit and In / Out for this dairy on this device.</small>
                </div>
            </div>

            <div class="dlg-msg success" *ngIf="editDairyMsg === 'success'"><i class="pi pi-check-circle"></i> Dairy info updated successfully!</div>
            <div class="dlg-msg error" *ngIf="editDairyMsg && editDairyMsg !== 'success'"><i class="pi pi-times-circle"></i> {{ editDairyMsg }}</div>
        </div>
        <div class="dlg-footer">
            <button class="dlg-btn secondary" (click)="showEditDairy=false">Cancel</button>
            <button class="dlg-btn primary" (click)="saveDairy()" [disabled]="dairyForm.invalid || savingDairy">
                <i class="pi" [ngClass]="savingDairy ? 'pi-spin pi-spinner' : 'pi-check'"></i>
                {{ savingDairy ? 'Saving...' : 'Update Dairy' }}
            </button>
        </div>
    </div>

    <!-- ── CHANGE PASSWORD DIALOG ── -->
    <div class="dlg-backdrop" *ngIf="showChangePassword"></div>
    <div class="dlg-panel" *ngIf="showChangePassword" [formGroup]="passwordForm">
        <div class="dlg-header">
            <div class="dlg-icon teal"><i class="pi pi-lock"></i></div>
            <div>
                <div class="dlg-title">Change Password</div>
                <div class="dlg-sub">Update your account password</div>
            </div>
            <button class="dlg-close" (click)="showChangePassword=false"><i class="pi pi-times"></i></button>
        </div>
        <div class="dlg-body">
            <div class="dlg-grid single">
                <div class="dlg-field">
                    <label>Current Password *</label>
                    <input type="password" formControlName="current_password" placeholder="Enter current password" />
                </div>
                <div class="dlg-field">
                    <label>New Password * <span class="dlg-hint">(min 6 characters)</span></label>
                    <input type="password" formControlName="new_password" placeholder="Enter new password" />
                </div>
                <div class="dlg-field">
                    <label>Confirm New Password *</label>
                    <input type="password" formControlName="confirm_password" placeholder="Re-enter new password" />
                    <div class="dlg-field-err" *ngIf="passwordForm.hasError('mismatch') && passwordForm.get('confirm_password')?.touched">Passwords do not match</div>
                </div>
            </div>
            <div class="dlg-msg success" *ngIf="changePwMsg === 'success'">
                <i class="pi pi-check-circle"></i> Password changed successfully!
            </div>
            <div class="pwd-session-choice" *ngIf="showPwdSessionChoice">
                <p>What would you like to do on this device?</p>
                <div class="pwd-session-btns">
                    <button class="dlg-btn secondary" (click)="signOutAfterPwdChange()">
                        <i class="pi pi-sign-out"></i> Sign out
                    </button>
                    <button class="dlg-btn primary" (click)="staySignedInAfterPwdChange()">
                        <i class="pi pi-check"></i> Stay signed in
                    </button>
                </div>
            </div>
            <div class="dlg-msg error" *ngIf="changePwMsg && changePwMsg !== 'success'"><i class="pi pi-times-circle"></i> {{ changePwMsg }}</div>
        </div>
        <div class="dlg-footer" *ngIf="!showPwdSessionChoice">
            <button class="dlg-btn secondary" (click)="showChangePassword=false">Cancel</button>
            <button class="dlg-btn primary" (click)="savePassword()" [disabled]="passwordForm.invalid || savingPassword">
                <i class="pi" [ngClass]="savingPassword ? 'pi-spin pi-spinner' : 'pi-lock'"></i>
                {{ savingPassword ? 'Updating...' : 'Update Password' }}
            </button>
        </div>
    </div>

    <!-- ── DELETE ACCOUNT DIALOG ── -->
    <div class="dlg-backdrop" *ngIf="showDeleteAccount"></div>
    <div class="dlg-panel dlg-danger" *ngIf="showDeleteAccount">
        <div class="dlg-header">
            <div class="dlg-icon red"><i class="pi pi-trash"></i></div>
            <div>
                <div class="dlg-title">Delete Account</div>
                <div class="dlg-sub">This action cannot be undone</div>
            </div>
            <button class="dlg-close" (click)="showDeleteAccount=false" [disabled]="deletingAccount"><i class="pi pi-times"></i></button>
        </div>
        <div class="dlg-body">
            <div class="danger-warning">
                <i class="pi pi-exclamation-triangle"></i>
                <div>
                    <strong>Account deletion is irreversible.</strong>
                    <p>Deleting your account will permanently remove all dairy data, members, milk collection records, and reports. This action <strong>cannot</strong> be undone.</p>
                </div>
            </div>
            <div class="dlg-grid single">
                <div class="dlg-field">
                    <label>Your Password *</label>
                    <div style="position:relative;display:flex;align-items:center">
                        <input [type]="deleteAccountPasswordVisible ? 'text' : 'password'"
                               [(ngModel)]="deleteAccountPassword"
                               placeholder="Enter your login password"
                               autocomplete="current-password"
                               style="padding-right:2.5rem"
                               [disabled]="deletingAccount" />
                        <button type="button" class="pwd-eye-btn"
                                (click)="deleteAccountPasswordVisible = !deleteAccountPasswordVisible"
                                tabindex="-1">
                            <i class="pi" [ngClass]="deleteAccountPasswordVisible ? 'pi-eye-slash' : 'pi-eye'"></i>
                        </button>
                    </div>
                </div>
                <div class="dlg-field">
                    <label>Type <strong>DELETE</strong> to confirm *</label>
                    <input type="text"
                           [(ngModel)]="deleteConfirmText"
                           placeholder="DELETE"
                           autocomplete="off"
                           [disabled]="deletingAccount" />
                </div>
            </div>
            <div class="dlg-msg error" *ngIf="deleteAccountMsg"><i class="pi pi-times-circle"></i> {{ deleteAccountMsg }}</div>
        </div>
        <div class="dlg-footer">
            <button class="dlg-btn secondary" (click)="showDeleteAccount=false" [disabled]="deletingAccount">Cancel</button>
            <button class="dlg-btn danger"
                    (click)="confirmDeleteAccount()"
                    [disabled]="deleteConfirmText !== 'DELETE' || !deleteAccountPassword || deletingAccount">
                <i class="pi" [ngClass]="deletingAccount ? 'pi-spin pi-spinner' : 'pi-trash'"></i>
                {{ deletingAccount ? 'Deleting...' : 'Delete My Account' }}
            </button>
        </div>
    </div>

    <!-- Main Content Area -->
    <div class="main-area">
        <!-- Topbar -->
        <header class="topbar">
            <div class="topbar-left">
                <button class="hamburger desktop-hamburger desktop-only" (click)="toggleDesktopSidebar()" title="Menu">
                    <i class="pi" [ngClass]="desktopSidebarOpen ? 'pi-times' : 'pi-bars'"></i>
                </button>
                <!-- Hamburger for mobile -->
                <button class="hamburger mobile-only" (click)="toggleMobile()" title="Menu">
                    <i class="pi pi-bars"></i>
                </button>
                <!-- Brand logo -->
                <a class="topbar-logo" routerLink="/dashboard" title="Milkomatic">
                    <img src="assets/milkomatic-logo.png" alt="Milkomatic" />
                </a>
                <h2 class="page-title">{{ pageTitle | translate }}</h2>
                <div class="topbar-dairy-chip" *ngIf="dairy">
                    <span class="tdc-name" [title]="dairy.company_name">{{ dairy.company_name }}</span>
                    <span class="tdc-sep">•</span>
                    <span class="tdc-id">ID: {{ dairy.id }}</span>
                </div>
                <div class="topbar-live-clock topbar-desktop-only">
                    <span class="clock-date">{{ liveDate }}</span>
                    <span class="clock-time">{{ liveTime }}</span>
                </div>

            </div>
            <div class="topbar-right">
                <!-- ── Menu Search (desktop/tablet topbar) ── -->
                <div class="menu-search">
                    <div class="menu-search-box">
                        <i class="pi pi-search ms-icon"></i>
                        <input
                            #menuSearchInput
                            type="text"
                            class="menu-search-input"
                            placeholder="Search menu..."
                            autocomplete="off"
                            [(ngModel)]="menuSearch"
                            (input)="onMenuSearchInput()"
                            (focus)="menuSearchOpen = true"
                            (keydown.escape)="closeMenuSearch()"
                            (keydown)="onMenuSearchKeydown($event)"
                        />
                        <kbd class="ms-kbd">Ctrl+/</kbd>
                    </div>
                    <div class="ms-backdrop" *ngIf="menuSearchOpen && menuSearch" (click)="closeMenuSearch()"></div>
                    <div class="menu-search-dropdown" *ngIf="menuSearchOpen && menuSearch && menuSearchResults.length > 0">
                        <button class="ms-item" *ngFor="let item of menuSearchResults; let i = index" [class.ms-active]="i === menuSearchActiveIndex" (click)="navigateFromSearch(item)">
                            <span class="ms-emoji">{{ item.emoji }}</span>
                            <span class="ms-label">{{ item.label }}</span>
                            <span class="ms-section">{{ item.section }}</span>
                        </button>
                    </div>
                    <div class="menu-search-dropdown ms-empty" *ngIf="menuSearchOpen && menuSearch && menuSearchResults.length === 0">
                        <i class="pi pi-search-minus"></i> No results for "{{ menuSearch }}"
                    </div>
                </div>

                <!-- Language Switcher (hidden on mobile — available in sidebar) -->
                <div class="lang-switcher-wrap topbar-desktop-only">
                    <button class="lang-toggle-btn" (click)="showLangMenu = !showLangMenu" [title]="'language.select' | translate">
                        <i class="pi pi-language"></i>
                        <span class="lang-current">{{ languageService.currentLanguage.nativeLabel }}</span>
                        <i class="pi pi-chevron-down lang-caret" [class.open]="showLangMenu"></i>
                    </button>
                    <div class="lang-backdrop" *ngIf="showLangMenu" (click)="showLangMenu = false"></div>
                    <div class="lang-menu" *ngIf="showLangMenu">
                        <button class="lang-option"
                            *ngFor="let lang of languages"
                            [class.active]="lang.code === currentLang"
                            (click)="switchLanguage(lang.code)">
                            <span class="lang-native">{{ lang.nativeLabel }}</span>
                            <span class="lang-name">{{ lang.label }}</span>
                            <i class="pi pi-check" *ngIf="lang.code === currentLang"></i>
                        </button>
                    </div>
                </div>
                <button class="theme-toggle-btn topbar-desktop-only" (click)="toggleTheme()" [title]="isDarkTheme ? ('topbar.light_mode' | translate) : ('topbar.dark_mode' | translate)">
                    <i class="pi" [ngClass]="isDarkTheme ? 'pi-sun' : 'pi-moon'"></i>
                </button>
                <app-notification-bell [userType]="'dairy'"></app-notification-bell>
                <div class="topbar-user-wrap" (click)="$event.stopPropagation()">
                    <div class="topbar-user" (click)="toggleProfile()">
                        <div class="topbar-avatar">{{ getInitial() }}</div>
                        <div class="topbar-user-info">
                            <span class="topbar-name">{{ currentUser?.name || 'User' }}</span>
                            <span class="topbar-role">{{ getUserRole() }}</span>
                        </div>
                        <i class="pi pi-chevron-down topbar-caret" [class.open]="showProfile"></i>
                    </div>

                    <!-- Profile Panel -->
                    <div class="profile-backdrop" *ngIf="showProfile" (click)="closeProfile()"></div>
                    <div class="profile-panel" *ngIf="showProfile">
                        <div class="pp-header">
                            <div class="pp-avatar">{{ getInitial() }}</div>
                            <div class="pp-header-text">
                                <div class="pp-title">User Profile</div>
                                <div class="pp-subtitle">Account Information</div>
                            </div>
                        </div>
                        <div class="pp-grid">
                            <div class="pp-field">
                                <div class="pp-label"><i class="pi pi-user"></i> FULL NAME</div>
                                <div class="pp-value">{{ currentUser?.name || '—' }}</div>
                            </div>
                            <div class="pp-field">
                                <div class="pp-label"><i class="pi pi-id-card"></i> USERNAME</div>
                                <div class="pp-value">{{ currentUser?.user_name || currentUser?.username || '—' }}</div>
                            </div>
                            <div class="pp-field">
                                <div class="pp-label"><i class="pi pi-envelope"></i> EMAIL</div>
                                <div class="pp-value">{{ currentUser?.email || '—' }}</div>
                            </div>
                            <div class="pp-field">
                                <div class="pp-label"><i class="pi pi-phone"></i> MOBILE</div>
                                <div class="pp-value">{{ currentUser?.mobile || '—' }}</div>
                            </div>
                            <div class="pp-field">
                                <div class="pp-label"><i class="pi pi-shield"></i> ROLE</div>
                                <div class="pp-value">{{ getUserRole() }}</div>
                            </div>
                            <div class="pp-field">
                                <div class="pp-label"><i class="pi pi-verified"></i> STATUS</div>
                                <div class="pp-value pp-status-active">{{ currentUser?.status || 'ACTIVE' }}</div>
                            </div>
                            <div class="pp-field pp-field-full">
                                <div class="pp-label"><i class="pi pi-clock"></i> LAST LOGIN</div>
                                <div class="pp-value">{{ currentUser?.last_login || currentUser?.updated_at || '—' }}</div>
                            </div>
                        </div>

                        <!-- Profile Quick Actions -->
                        <div class="pp-actions" *ngIf="!isStaffUser">
                            <button class="pp-action-btn" (click)="openEditProfile(); closeProfile()" title="Edit Profile">
                                <i class="pi pi-user-edit"></i>
                                <span>Edit Profile</span>
                            </button>
                            <button class="pp-action-btn" (click)="openChangePassword(); closeProfile()" title="Change Password">
                                <i class="pi pi-lock"></i>
                                <span>Change Password</span>
                            </button>
                            <button class="pp-action-btn danger" (click)="openDeleteAccount(); closeProfile()" title="Delete Account">
                                <i class="pi pi-trash"></i>
                                <span>Delete Account</span>
                            </button>
                        </div>

                        <!-- Logout -->
                        <button class="pp-logout-btn" (click)="logout()">
                            <i class="pi pi-sign-out"></i>
                            <span>Logout</span>
                        </button>
                    </div>
                </div>
            </div>
        </header>

        <!-- Offline banner -->
        <div class="offline-banner" *ngIf="!(offlineService.isOnline$ | async)">
          <i class="pi pi-wifi"></i>
          <span>You are <strong>offline</strong>. Using cached data where available.</span>
          <span class="offline-queue" *ngIf="offlineService.getQueueCount() > 0">
            {{ offlineService.getQueueCount() }} milk entr{{ offlineService.getQueueCount() === 1 ? 'y' : 'ies' }} queued for sync
          </span>
        </div>

        <!-- Tab Bar (web/desktop only — hidden via CSS on mobile viewports) -->
        <div class="tab-bar-wrap" *ngIf="tabService.isEnabled && tabService.tabs.length > 0">
            <div class="tab-overflow-backdrop" *ngIf="showTabOverflowMenu" (click)="showTabOverflowMenu = false"></div>
            <div class="tab-bar-shell">
                <div class="tab-bar" #tabBarViewport>
                    <div class="tab-item"
                        *ngFor="let tab of visibleTabs"
                        [class.active]="tab.id === tabService.activeId"
                        (click)="tabService.activateTab(tab.id)"
                        [title]="tab.labelKey ? (tab.labelKey | translate) : tab.label">
                        <i class="pi {{ tab.icon }} tab-icon"></i>
                        <span class="tab-label">{{ tab.labelKey ? (tab.labelKey | translate) : tab.label }}</span>
                        <button class="tab-close"
                            *ngIf="tab.closable"
                            (click)="onCloseTab($event, tab.id)"
                            title="Close">
                            <i class="pi pi-times"></i>
                        </button>
                    </div>

                    <div class="tab-switcher" *ngIf="tabService.tabs.length > 1">
                        <button
                            class="tab-switcher-trigger"
                            [class.active]="showTabSwitcher"
                            (click)="toggleTabSwitcher($event)"
                            title="Tab switcher (Alt+W)">
                            <i class="pi pi-th-large"></i>
                        </button>
                    </div>

                    <div class="tab-overflow" *ngIf="tabService.tabs.length > 1">
                        <button
                            class="tab-overflow-trigger"
                            [class.active]="showTabOverflowMenu"
                            (click)="toggleTabOverflowMenu($event)"
                            title="More tabs">
                            <i class="pi pi-angle-double-down"></i>
                        </button>

                        <div class="tab-overflow-menu" *ngIf="showTabOverflowMenu">
                            <div
                                class="tab-overflow-item"
                                *ngFor="let tab of tabService.tabs"
                                [class.active]="tab.id === tabService.activeId"
                                (click)="activateOverflowTab(tab)"
                                [title]="tab.labelKey ? (tab.labelKey | translate) : tab.label">
                                <span class="tab-overflow-check">
                                    <i class="pi pi-check" *ngIf="tab.id === tabService.activeId"></i>
                                </span>
                                <span class="tab-overflow-main">
                                    <i class="pi {{ tab.icon }} tab-icon"></i>
                                    <span class="tab-overflow-label">{{ tab.labelKey ? (tab.labelKey | translate) : tab.label }}</span>
                                </span>
                                <button
                                    class="tab-close tab-overflow-close"
                                    *ngIf="tab.closable"
                                    (click)="closeOverflowTab($event, tab.id)"
                                    title="Close">
                                    <i class="pi pi-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tab-switcher-backdrop" *ngIf="showTabSwitcher" (click)="closeTabSwitcher()"></div>
        <div class="tab-switcher-panel" *ngIf="showTabSwitcher">
            <div class="tab-switcher-header">
                <div>
                    <div class="tab-switcher-title">Open Tabs</div>
                    <div class="tab-switcher-subtitle">Use arrow keys, Enter, or click to switch</div>
                </div>
                <div class="tab-switcher-hint">Alt+W</div>
            </div>

            <div class="tab-switcher-list">
                <div
                    class="tab-switcher-item"
                    #tabSwitcherItem
                    *ngFor="let tab of tabService.tabs; let i = index"
                    [class.active]="tab.id === tabService.activeId"
                    [class.focused]="i === tabSwitcherIndex"
                    (mouseenter)="setTabSwitcherIndex(i)"
                    (click)="activateTabSwitcherTab(tab)">
                    <div class="tab-switcher-main">
                        <span class="tab-switcher-icon-wrap"><i class="pi {{ tab.icon }}"></i></span>
                        <div class="tab-switcher-copy">
                            <div class="tab-switcher-label">{{ tab.labelKey ? (tab.labelKey | translate) : tab.label }}</div>
                            <div class="tab-switcher-route">{{ tab.route }}</div>
                        </div>
                    </div>
                    <div class="tab-switcher-actions">
                        <span class="tab-switcher-badge" *ngIf="tab.id === tabService.activeId">Active</span>
                        <button
                            class="tab-switcher-close"
                            *ngIf="tab.closable"
                            (click)="closeTabSwitcherTab($event, tab.id)"
                            title="Close">
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Page Content -->
        <main class="content" [class.sp-tablet-page-active]="isSalesOrPurchasePage()">
            <router-outlet></router-outlet>
        </main>

        <!-- ── Bottom Navigation Bar ── -->
        <nav class="bottom-nav">
            <a class="bn-item"
               [routerLink]="(tabService.isEnabled || isBottomNavRouteDisabled('/dashboard')) ? null : '/dashboard'"
               [class.bn-active]="isActiveRoute('/dashboard')"
               [class.bn-disabled]="isBottomNavRouteDisabled('/dashboard')"
               [attr.aria-disabled]="isBottomNavRouteDisabled('/dashboard')"
               (click)="onBottomNavItemClick('/dashboard', 'Dashboard', 'pi-home')">
                <i class="pi pi-home"></i>
                <span>{{ 'nav.home' | translate }}</span>
                <i class="pi pi-lock bn-lock" *ngIf="isBottomNavRouteDisabled('/dashboard')"></i>
            </a>
            <a class="bn-item"
               [routerLink]="(tabService.isEnabled || isBottomNavRouteDisabled('/milk-sale')) ? null : '/milk-sale'"
               [class.bn-active]="isActiveRoute('/milk-sale')"
               [class.bn-disabled]="isBottomNavRouteDisabled('/milk-sale')"
               [attr.aria-disabled]="isBottomNavRouteDisabled('/milk-sale')"
               (click)="onBottomNavItemClick('/milk-sale', 'Milk Sale', 'pi-shopping-cart')">
                <i class="pi pi-shopping-cart"></i>
                <span>{{ 'nav.milk_sale' | translate }}</span>
                <i class="pi pi-lock bn-lock" *ngIf="isBottomNavRouteDisabled('/milk-sale')"></i>
            </a>
            <!-- Desktop-only: Payments -->
            <a class="bn-item bn-desktop-only"
               [routerLink]="(tabService.isEnabled || isBottomNavRouteDisabled('/payments')) ? null : '/payments'"
               [class.bn-active]="isActiveRoute('/payments')"
               [class.bn-disabled]="isBottomNavRouteDisabled('/payments')"
               [attr.aria-disabled]="isBottomNavRouteDisabled('/payments')"
               (click)="onBottomNavItemClick('/payments', 'Payments', 'pi-wallet')">
                <i class="pi pi-wallet"></i>
                <span>{{ 'nav.payments' | translate }}</span>
                <i class="pi pi-lock bn-lock" *ngIf="isBottomNavRouteDisabled('/payments')"></i>
            </a>
                <a class="bn-item bn-tablet-desktop-only"
               [routerLink]="(tabService.isEnabled || isBottomNavRouteDisabled('/receipts')) ? null : '/receipts'"
               [class.bn-active]="isActiveRoute('/receipts')"
               [class.bn-disabled]="isBottomNavRouteDisabled('/receipts')"
               [attr.aria-disabled]="isBottomNavRouteDisabled('/receipts')"
                   (click)="onBottomNavItemClick('/receipts', 'Receipts', 'pi-money-bill')">
                    <i class="pi pi-money-bill"></i>
                <span>{{ 'nav.receipts' | translate }}</span>
                <i class="pi pi-lock bn-lock" *ngIf="isBottomNavRouteDisabled('/receipts')"></i>
            </a>
            <!-- Center FAB: Milk Collection -->
            <div class="bn-fab-wrap">
                <button class="bn-fab"
                        [class.bn-fab-active]="isActiveRoute('/milk-collection')"
                        [class.bn-fab-disabled]="isBottomNavRouteDisabled('/milk-collection')"
                        [disabled]="isBottomNavRouteDisabled('/milk-collection')"
                        (click)="onBottomNavItemClick('/milk-collection', 'Milk Collection', 'pi-inbox')"
                        title="Milk Collection">
                    <span class="bn-fab-emoji">🚜</span>
                </button>
                <span class="bn-fab-label" [class.bn-fab-label-disabled]="isBottomNavRouteDisabled('/milk-collection')">
                    {{ 'nav.milk_collection' | translate }}
                    <i class="pi pi-lock bn-fab-lock" *ngIf="isBottomNavRouteDisabled('/milk-collection')"></i>
                </span>
            </div>
            <!-- Desktop-only: Members -->
            <a class="bn-item bn-desktop-only"
               [routerLink]="(tabService.isEnabled || isBottomNavRouteDisabled('/members')) ? null : '/members'"
               [class.bn-active]="isActiveRoute('/members')"
               [class.bn-disabled]="isBottomNavRouteDisabled('/members')"
               [attr.aria-disabled]="isBottomNavRouteDisabled('/members')"
               (click)="onBottomNavItemClick('/members', 'Members', 'pi-users')">
                <i class="pi pi-users"></i>
                <span>{{ 'nav.members' | translate }}</span>
                <i class="pi pi-lock bn-lock" *ngIf="isBottomNavRouteDisabled('/members')"></i>
            </a>
            <!-- Desktop-only: Daybook -->
            <a class="bn-item bn-desktop-only"
               [routerLink]="(tabService.isEnabled || isBottomNavRouteDisabled('/daybook')) ? null : '/daybook'"
               [class.bn-active]="isActiveRoute('/daybook')"
               [class.bn-disabled]="isBottomNavRouteDisabled('/daybook')"
               [attr.aria-disabled]="isBottomNavRouteDisabled('/daybook')"
               (click)="onBottomNavItemClick('/daybook', 'Daybook', 'pi-book')">
                <i class="pi pi-book"></i>
                <span>{{ 'nav.daybook' | translate }}</span>
                <i class="pi pi-lock bn-lock" *ngIf="isBottomNavRouteDisabled('/daybook')"></i>
            </a>
            <a class="bn-item"
               [routerLink]="(tabService.isEnabled || isBottomNavRouteDisabled('/reports')) ? null : '/reports'"
               [class.bn-active]="isActiveRoute('/reports')"
               [class.bn-disabled]="isBottomNavRouteDisabled('/reports')"
               [attr.aria-disabled]="isBottomNavRouteDisabled('/reports')"
               (click)="onBottomNavItemClick('/reports', 'Reports', 'pi-chart-bar')">
                <i class="pi pi-chart-bar"></i>
                <span>{{ 'nav.reports' | translate }}</span>
                <i class="pi pi-lock bn-lock" *ngIf="isBottomNavRouteDisabled('/reports')"></i>
            </a>
            <button class="bn-item bn-more-btn"
                    (click)="toggleBottomDrawer()"
                    [class.bn-active]="showBottomDrawer">
                <i class="pi pi-th-large"></i>
                <span>{{ 'nav.more' | translate }}</span>
            </button>
        </nav>
    </div>

    <!-- ── Bottom Drawer ── -->
    <div class="bottom-drawer-backdrop" *ngIf="showBottomDrawer" (click)="showBottomDrawer = false"></div>
    <div class="bottom-drawer" [class.open]="showBottomDrawer" [class.bottom-drawer--right]="bottomDrawerPlacement === 'right'">
        <div class="bd-handle"></div>
        <div class="bd-header">
            <div class="bd-header-title-wrap">
                <span class="bd-title">{{ 'nav.all_menus' | translate }}</span>
                <div class="bd-placement-toggle" title="Choose how the More drawer opens">
                    <button type="button"
                            class="bd-placement-btn"
                            [class.active]="bottomDrawerPlacement === 'bottom'"
                            (click)="setBottomDrawerPlacement('bottom')">
                        Bottom
                    </button>
                    <button type="button"
                            class="bd-placement-btn"
                            [class.active]="bottomDrawerPlacement === 'right'"
                            (click)="setBottomDrawerPlacement('right')">
                        Right
                    </button>
                </div>
            </div>
            <button class="bd-close-btn" (click)="showBottomDrawer = false">
                <i class="pi pi-times"></i>
            </button>
        </div>
        <div class="bd-scroll">
            <ng-container *ngFor="let sec of navSections">
                <ng-container *ngIf="getDrawerItemsBySection(sec.key).length > 0">
                    <div class="bd-section-label">{{ sec.labelKey | translate }}</div>
                    <div class="bd-grid">
                        <a class="bd-item"
                           *ngFor="let item of getDrawerItemsBySection(sec.key)"
                           [routerLink]="(item.comingSoon || isNavLocked(item) || tabService.isEnabled) ? null : item.route"
                           [class.bd-disabled]="item.comingSoon || isNavLocked(item)"
                           [class.bd-addon-buy]="isNavLocked(item) && (item.planFeature === 'production' || item.planFeature === 'storage_locations')"
                           (click)="onDrawerItemClick(item)">
                            <div class="bd-item-icon" [style.background]="getItemGradient(item)">
                                <i class="pi {{ item.icon }}"></i>
                            </div>
                            <span class="bd-item-label">{{ item.labelKey | translate }}</span>
                            <span class="bd-item-soon" *ngIf="item.comingSoon">Soon</span>
                            <span class="bd-item-lock" *ngIf="isNavLocked(item)">🔒</span>
                        </a>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>

<app-stock-location-prompt></app-stock-location-prompt>
